import React, { useState } from 'react'
import Header from '../Header';
import swal from 'sweetalert'
import { useNavigate } from 'react-router-dom';

const loginUrl = `https://zomatourl.herokuapp.com/login`

const Login = () => {
  const navigate = useNavigate()
  const [token, setToken] = useState(false)
  console.log(token);
  const [user, setUser] = useState({
    email: "abdul@gmail.com",
    password: "abdul"
  })

  let name, value;

  const changeHandle = (e) => {
    name = e.target.name;
    value = e.target.value;
    setUser({ ...user, [name]: value })
  }

  const clickHandle = () => {
    const { email, password } = user;
    fetch(loginUrl, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body : JSON.stringify({
        email,password
      })
    })
    .then(res => res.json())
    .then(data => {
      if (data.auth === false) {
        setToken({msg : data.token})
        swal({
          title : "Something Went Wrong",
          text : data.token, /* token.msg */
          icon : "warning",
          button : "Opps"
        })
      } else {
        localStorage.setItem("authToken", data.token)
        swal({
          title : "Great",
          text : "Login Successfully",
          icon : "success",
          button : "Aww yiss!"
        })
        navigate("/")
      }
    })
    .catch(err => {
      console.log(err);
    })
  }

  return (
    <React.Fragment>
      <Header />
      <div className="container border p-3 mt-5">
        <form>
          <div className="mb-3">
            <label htmlFor="email" className="form-label">Email</label>
            <input type="email" name='email' className="form-control" id="email" value={user.email} onChange={changeHandle} />
          </div>

          <div className="mb-3">
            <label htmlFor="email" className="form-label">Password</label>
            <input type="text" name='password' className="form-control" id="password" value={user.password} onChange={changeHandle} />
          </div>

          <button type="button" className="btn btn-primary" onClick={clickHandle}>Submit</button>
        </form>
      </div>
    </React.Fragment>
  )
}

export default Login